import type { PaginationState } from '@tanstack/react-table'
import { format } from 'date-fns'
import type { DateRange } from 'react-day-picker'
import { useQuery } from 'react-query'

import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'
import { handleError } from '@/utils/error'

interface Params {
  pagination: PaginationState
  creatorId?: string
  memberId?: string
  word?: string
  date: DateRange
}

export function useRestrictedWordLogs({
  pagination,
  memberId,
  creatorId,
  word,
  date,
}: Params) {
  const { data, isLoading, isFetching } = useQuery(
    [
      'restrictedWordLogs',
      pagination.pageSize,
      pagination.pageIndex,
      memberId,
      creatorId,
      word,
      date,
    ],
    () =>
      restrictedWordsService.getRestrictedWordsLogs({
        page: pagination.pageIndex,
        size: pagination.pageSize,
        memberId,
        creatorId,
        word,
        fromDate: date?.from
          ? format(date.from, "yyyy-MM-dd'T'HH:mm:ss.SSS")
          : undefined,
        endDate: date?.to
          ? format(date.to, "yyyy-MM-dd'T'HH:mm:ss.SSS")
          : undefined,
      }),
    {
      onError: (error) =>
        handleError(error, 'Failed to get restricted word logs'),
    },
  )

  return {
    restrictedWordLogsResponse: data,
    isRestrictedWordLogsLoading: isLoading,
    isRestrictedWordLogsFetching: isFetching,
  }
}
